import { SHStack, SHToggleButtonOptions } from "@components/design-systems";
import { useFeeCalculatorInputField } from "@hooks/useFeeCalculatorInputField";
import { FeeCalculatorRenderFieldProps } from "@models/platform-analysis/entities/steps/fee";
import { FeeCalculatorPortfolioLevel } from "@models/platform-analysis/enums/fee/portfolioLevel";
import { FeeCalculatorPortfolioLevelOptions } from "@pages/platform-analysis/constant";
import { setPortfolioLevel } from "@redux/slices/platform-analysis";
import { useAppDispatch } from "@redux/store";
import { memo } from "react";
import { Controller } from "react-hook-form";
import { useMount } from "react-use";

export const PortfolioLevelToggleButtonOptions = memo(
  ({ fieldConfig, disabled }: FeeCalculatorRenderFieldProps) => {
    const dispatch = useAppDispatch();
    const { singleVariableName } = fieldConfig;
    const {
      formMethods: { control, getValues },
      fieldPath,
    } = useFeeCalculatorInputField(singleVariableName);

    const handleOnValueChange = (value: FeeCalculatorPortfolioLevel) => {
      dispatch(setPortfolioLevel(value));
    };

    useMount(() => {
      const initLevel = getValues(fieldPath);
      if (!initLevel) return;
      dispatch(setPortfolioLevel(initLevel as FeeCalculatorPortfolioLevel));
    });

    return (
      <SHStack
        width={"100%"}
        alignItems={"start"}
        sx={{ width: { xs: "100%", md: 520 } }}
      >
        <Controller
          control={control}
          name={fieldPath}
          render={({ field: { onChange, value, ...others } }) => {
            return (
              <SHToggleButtonOptions
                {...others}
                disabled={disabled}
                tooltipPlacement={"top"}
                tooltipSx={{
                  marginLeft: 0,
                  width: 200,
                }}
                options={FeeCalculatorPortfolioLevelOptions}
                value={value}
                onChange={(_, value) => {
                  if (!value) return;
                  onChange(value);
                  handleOnValueChange(value);
                }}
              />
            );
          }}
        />
      </SHStack>
    );
  },
);
